import { useSubscribedPlan } from '../../modules/renew-plan/v1/hooks/use-subscribed-plan';
import { ProductPlan } from '../../modules/renew-plan/v1/typings';
import { useSelectedOrganization } from '../hooks/use-organizations';

/** Org IDs that have search access even on STANDARD plan */
const STANDARD_PLAN_SEARCH_ACCESS_ORG_IDS: readonly string[] = ['org_68vPUJXzxv'];

export const useIsStandardPlanWithRestrictedSearch = (): boolean => {
  const { subscribedPlan } = useSubscribedPlan(false);
  const selectedOrg = useSelectedOrganization();
  return (
    subscribedPlan?.id === ProductPlan.STANDARD &&
    !STANDARD_PLAN_SEARCH_ACCESS_ORG_IDS.includes(selectedOrg?.orgId ?? '')
  );
};
